import axios from 'axios';
import namespace from './namespace';
import consts from './consts';
import AppService from './../../../service/app.js';
import SmtpConfigurationService from './../../../service/smtpConfiguration.js';
import { NAMESPACE as APP_NAMESPACE } from './../app';

let appService = new AppService();
let service = new SmtpConfigurationService(axios);

export default {
    async [namespace.actions.FETCH] ({ commit, dispatch }) {
        try {
            commit(namespace.mutations.DISABLE_VIEW, consts.LOADING_MESSAGES.FETCH);
            commit(namespace.mutations.SET_CONFIGURATION, await service.fetchConfiguration());
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        } finally {
            commit(namespace.mutations.ENABLE_VIEW);
        }
    },
    async [namespace.actions.SAVE] ({ commit, state, dispatch }) {
        try {
            let configuration = createConfigurationObjectForRequest(state[namespace.state.CONFIGURATION]);
            commit(namespace.mutations.SET_VIEW_NOTIFICATION, consts.VIEW_NOTIFICATIONS.NONE);
            commit(namespace.mutations.DISABLE_VIEW, consts.LOADING_MESSAGES.SAVE);
            commit(namespace.mutations.SET_CONFIGURATION, await service.saveConfiguration(configuration));
            commit(namespace.mutations.SET_VIEW_NOTIFICATION, consts.VIEW_NOTIFICATIONS.SAVED);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        } finally {
            commit(namespace.mutations.ENABLE_VIEW);
        }
    },
    async [namespace.actions.TEST] ({ commit, state, dispatch }) {
        try {
            let configuration = createConfigurationObjectForRequest(state[namespace.state.CONFIGURATION]);
            commit(namespace.mutations.SET_VIEW_NOTIFICATION, consts.VIEW_NOTIFICATIONS.NONE);
            commit(namespace.mutations.DISABLE_VIEW, consts.LOADING_MESSAGES.TEST.replace("{EMAIL}", configuration.ToEmailAddress));
            await service.testConfiguration(configuration);
            commit(namespace.mutations.SET_VIEW_NOTIFICATION, consts.VIEW_NOTIFICATIONS.TEST_PASSED);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        } finally {
            commit(namespace.mutations.ENABLE_VIEW);
        }
    },
    [namespace.actions.CONFIRM_REMOVE]({commit, dispatch}, configurationId) {
        let message = 'Are you sure you want to remove SMTP configuration?';
        dispatch(
            APP_NAMESPACE.actions.SEND_NOTIFICATION, {
                receiver: 'MessageBox',
                payload: {
                    title: 'Confirm', message: message, buttons: [
                        {
                            title: 'Cancel'
                        },
                        {
                            title: 'Remove',
                            onClickHandler: () => {
                                dispatch(namespace.actions.REMOVE, configurationId);
                            }
                        }
                    ]
                }
            },
            {root: true}
        );
    },
    async [namespace.actions.REMOVE] ({commit, dispatch}, configurationId) {
        try {
            commit(namespace.mutations.DISABLE_VIEW, consts.LOADING_MESSAGES.REMOVE);
            commit(namespace.mutations.SET_CONFIGURATION, await service.removeConfiguration(configurationId));
        } catch(err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        } finally {
            commit(namespace.mutations.ENABLE_VIEW);
        }
    },
    [namespace.actions.SET_UP_SERVICE] ({}, payload) {
        if (payload.service !== undefined) {
            service = payload.service;
        }
        if (payload.prefix !== undefined) {
            service.backendUrl = payload.prefix;
        }
    },
    [namespace.actions.HANDLE_ERROR] ({dispatch, commit}, err) {
        let error = appService.extractMessageFromErrorObject(err);
        let notification = Object.assign({}, consts.VIEW_NOTIFICATIONS.ERROR, {
            error: error
        });
        commit(namespace.mutations.SET_VIEW_NOTIFICATION, notification);
    }
};

function createConfigurationObjectForRequest(configurationFromState) {
    return Object.assign({}, configurationFromState, {IsEnabled: configurationFromState.Enabled});
};



// WEBPACK FOOTER //
// ./src/store/modules/smtp/actions.js